import { makeStyles } from '@material-ui/core';
import { format } from 'date-fns';
import React from 'react';
import Navbar from './navbar';
import StyledDayPicker from './styled-day-picker';

const useStyles = makeStyles((theme) => ({
  '@global': {
    '.DayPicker': {
      '&-NavButton': { position: 'absolute', width: 32, height: 32, '&--next': { right: 20 } },

      '&-Months': { display: 'flex', '& > * + *': { marginLeft: 16 } },

      '&-Day': {
        '&--selected:not(&--outside):not(&--from):not(&--to)': {
          ...theme.typography.body1,
          backgroundColor: theme.colors.greyF7,
          color: theme.colors.grey66,
          borderRadius: 'unset',
        },

        '&--selected:not(&--outside):not(&--from):not(&--to):hover': {
          ...theme.typography.button,
          backgroundColor: theme.colors.grey99,
          color: theme.colors.white,
          borderRadius: theme.borderRadius.small,
        },

        '&--from:not(&--outside), &--to:not(&--outside)': {
          backgroundColor: theme.colors.grey66,
          color: theme.palette.common.white,
          borderRadius: theme.borderRadius.small,
        },
      },
    },
  },
}));

const RangeDayPicker = React.forwardRef((props, ref) => {
  useStyles();
  return (
    <StyledDayPicker
      captionElement={({ date }) => (
        <div className="DayPicker-Caption">{format(date, 'MMM yyyy')}</div>
      )}
      navbarElement={(navbarProps) => <Navbar {...navbarProps} />}
      numberOfMonths={2}
      {...props}
      ref={ref}
    />
  );
});

export default RangeDayPicker;
